<template>
  <v-dialog v-model="dialogManutExpProf" persistent max-width="700">
    <v-card>
      <v-card-title class="font-weight-bold primary--text"
        >{{ editar > 0 ? "Editar" : "Adicionar" }} experiência
        profissional</v-card-title
      >
      <v-card-text>
        <v-form ref="form">
          <v-row dense>
            <v-col cols="12">
              <v-combobox
                label="Empresa"
                :items="empresas_func"
                item-text="nome"
                item-value="nome"
                hide-no-data
                v-model="empresaModel"
              ></v-combobox>
              <!--<v-text-field
                autofocus
                label="*Empresa"
                v-model="empresaModel"
                :rules="[
                  (v) => v.length > 3 || 'Empresa precisa ser informada',
                ]"
              ></v-text-field>-->
            </v-col>
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Data de admissão"
                type="date"
                v-model="experiencia.admissao"
              ></v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" cols="12">
              <v-text-field
                label="Data de desligamento"
                type="date"
                v-model="experiencia.desligamento"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                label="*Cargo"
                placeholder="Informe o último cargo que exerceu nesta empresa"
                :rules="[(v) => v.length > 3 || 'Cargo precisa ser informado']"
                v-model="cargoModel"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <h4 class="font-weight-bold primary--text">
                Localização da empresa
              </h4>

              <v-row>
                <v-col xl="3" lg="3" md="3" cols="12">
                  <v-select
                    label="*País"
                    :items="locais"
                    item-text="descricao"
                    item-value="codigo"
                    v-model="experiencia.pais"
                    no-data-text="Nenhum país disponível"
                    :rules="[(v) => !!v || 'País precisa ser informado']"
                  ></v-select>
                </v-col>
                <v-col xl="3" lg="3" md="3" cols="12">
                  <v-select
                    label="*UF"
                    :items="getUfs()"
                    item-text="codigo"
                    item-value="codigo"
                    v-model="experiencia.uf"
                    no-data-text="Nenhuma uf disponível"
                    :rules="[(v) => !!v || 'UF precisa ser informada']"
                    @change="experiencia.cidade = 0"
                  ></v-select>
                </v-col>
                <v-col xl="6" lg="6" md="6" cols="12">
                  <v-select
                    label="*Cidade"
                    no-data-text="Nenhuma cidade disponível"
                    :rules="[(v) => v > 0 || 'Cidade precisa ser informada']"
                    v-model="experiencia.cidade"
                    :items="getCidades()"
                    item-text="descricao"
                    item-value="codigo"
                  ></v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-row dense class="mb-1">
          <v-col cols="6">
            <v-btn
              rounded
              @click="salvarExperienciaProf()"
              color="secondary primary--text font-weight-bold"
              depressed
              block
              >Confirmar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              rounded
              @click="setDialogManutExpProf(false)"
              depressed
              block
              color="grey lighten-2"
              >Cancelar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapMutations, mapState } from "vuex";
export default {
  watch: {
    dialogManutExpProf: function (open) {
      if (open) {
        this.editar = this.experiencia.id > 0;
      }
    },
  },
  computed: {
    ...mapState([
      "dialogManutExpProf",
      "experiencia",
      "locais",
      "candidato",
      "empresas_func",
    ]),
    dialogModel: {
      get: function () {
        return this.dialogManutExpProf;
      },
      set: function (value) {
        this.setDialogManutExpProf(value);
      },
    },
    cargoModel: {
      get: function () {
        return this.experiencia.cargo;
      },
      set: function (value) {
        this.$store.state.experiencia.cargo = value.toUpperCase();
      },
    },
    empresaModel: {
      get: function () {
        return this.experiencia.empresa;
      },
      set: function (value) {
        if (value.nome)
          this.$store.state.experiencia.empresa = value.nome.toUpperCase();
        else this.$store.state.experiencia.empresa = value.toUpperCase();
      },
    },
  },
  data: () => ({
    editar: false,
  }),
  methods: {
    ...mapMutations(["setDialogManutExpProf"]),
    getUfs() {
      const pais = this.locais.find((l) => l.codigo == this.experiencia.pais);
      return pais && pais.ufs ? pais.ufs : [];
    },
    getCidades() {
      if (this.experiencia.uf != "") {
        const pais = this.locais.find((l) => l.codigo == this.experiencia.pais);
        if (pais && pais.ufs) {
          const uf = pais.ufs.find((uf) => uf.codigo == this.experiencia.uf);
          return uf && uf.cidades ? uf.cidades : [];
        }
      }
      return [];
    },
    getCidadeSelecionada() {
      return this.getCidades().find(
        (cid) => cid.codigo == this.experiencia.cidade,
      );
    },
    salvarExperienciaProf() {
      if (this.$refs.form.validate()) {
        if (
          moment(this.experiencia.admissao).isAfter(
            moment(this.experiencia.desligamento),
          )
        ) {
          this.$toasted.error(
            "Data de admissão não pode ser maior que a data de desligamento",
          );
          return;
        }

        if (moment(this.experiencia.admissao).isAfter(moment())) {
          this.$toasted.error("Data de admissão inválida");
          return;
        }

        if (moment(this.experiencia.desligamento).isAfter(moment())) {
          this.$toasted.error("Data de desligamento inválida");
          return;
        }

        this.experiencia.desc_cidade =
          this.getCidadeSelecionada().descricao.toUpperCase() ?? "";
        if (this.editar) {
          Object.assign(
            this.candidato.experienciasprofissionais.find(
              (exp) => exp.id == this.experiencia.id,
            ),
            this.experiencia,
          );
        } else {
          this.experiencia.id = 0;
          this.candidato.experienciasprofissionais.push({
            ...this.experiencia,
          });
        }

        this.setDialogManutExpProf(false);
      }
    },
  },
};
</script>

<style></style>
